import React from "react";
import PopupModules from "src/features/auth/components/PopupModules";
import { Button } from "src/business-types/grocery/components/Button";

interface Props {
    names: string[];
    onCancel: () => void;
    onConfirm: () => void;
}

export default function DeleteConfirmModal({ names, onCancel, onConfirm }: Props) {
    return (
        <PopupModules isOpen onClose={onCancel} title="Confirm Deletion">
            <div className="px-4 py-3 text-center">
                <p className="text-sm text-gray-600 mb-4">
                    The following products will be{" "}
                    <span className="text-red-600 font-semibold">DELETED</span>.
                    <br />
                    This action <span className="font-bold">cannot be undone.</span>
                </p>
                <div className="max-h-40 overflow-y-auto bg-gray-50 border rounded-md p-3 mb-5">
                    {names.map((name, i) => (
                        <div key={i} className="text-sm text-gray-700 py-1 border-b last:border-0">
                            {i + 1}. {name}
                        </div>
                    ))}
                </div>
                <div className="flex justify-center gap-4">
                    <Button label="Cancel" variant="cancel" onClick={onCancel} />
                    <Button label="Delete" variant="danger" onClick={onConfirm} />
                </div>
            </div>
        </PopupModules>
    );
}